// frontend/src/components/RatingSphere3D.js
import React from 'react';
import SphereMenu from './SphereMenu';

const RatingSphere3D = ({ onSelect, radius = 2, initialIndex = 9, scale = 0.75 }) => {
  // Generate options 1 to 10
  const options = Array.from({ length: 10 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
    content: String(i + 1)
  }));

  const handleSelect = (val) => {
    if (onSelect) {
      // If val is empty string, it means unlocked/deselected
      onSelect(val ? parseInt(val, 10) : null);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '165px' }}>
      <div style={{ width: '135px', height: '135px' }}>
        <SphereMenu
          options={options}
          radius={radius}
          onSelect={handleSelect}
          style={{ height: '100%' }}
          initialIndex={initialIndex}
          scale={scale}
          compact={true}
        />
      </div>
    </div>
  );
};

export default RatingSphere3D;
